module.exports = __webpack_public_path__ + "static/media/game-background-synonyms.b46663f7.jpg";